import clsx from 'clsx'
import {ChangeEvent} from 'react'

interface CheckboxProps {
  label: string
  checked?: boolean
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  idLabel?: string
  idInput?: string
  error?: boolean
  required?: boolean
  labelLink?: string
  bgColor?: string
  borderColor?: string
}

export const Checkbox = ({
  label,
  checked,
  onChange,
  idInput,
  idLabel,
  error,
  required,
  labelLink,
  bgColor = '#252E5B',
}: CheckboxProps) => {
  return (
    <label
      className={clsx('flex cursor-pointer items-center', error ? 'text-red-500' : 'text-white')}
    >
      <div
        style={{
          backgroundColor: checked ? '#fff' : bgColor,
        }}
        className={clsx(
          'flex h-6 w-6 items-center justify-center rounded-md border transition-colors',
          !error &&
            'border-[rgba(255,255,255,0.3)] hover:border-[rgba(255,255,255,0.6)] focus:border-[rgba(255,255,255)]',
          error && 'border-red-500',
        )}
      >
        <svg
          className={clsx(
            'h-4 w-4 text-black transition-opacity',
            checked ? 'opacity-100' : 'opacity-0',
          )}
          fill="none"
          stroke="currentColor"
          strokeWidth="5"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <input
        id={idInput}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="hidden"
      />
      <span className="ml-3" id={idLabel}>
        {labelLink ? (
          <a href={labelLink} target="_blank" className="pointer underline">
            {label}
          </a>
        ) : (
          label
        )}
      </span>
      {required && <span className="ml-1 text-red-500">*</span>}
    </label>
  )
}
